const fr = {
  welcome: {
    tagline1: 'Faites vos choix.',
    tagline2: 'Grimpez au classement.',
    tagline3: 'Gagnez des prix.',
    howToPlay: 'Comment jouer',
    letsPlay: 'Jouez',
  },
  howToPlay: {
    back: 'Retour',
    title: 'Comment jouer',
    step1Title: "Pick'Em",
    step1Description: 'Verrouillez vos prédictions avant le début du match',
    step2Title: 'Marquez gros',
    step2Description: 'Chaque bon choix vous rapporte des points',
    step3Title: 'Battez la concurrence',
    step3Description: 'Dépassez amis et partisans au classement',
    step4Title: 'À vous la gloire',
    step4Description: 'Gagnez des prix et montrez qui est le meilleur',
    cta: 'Jouez',
  },
  game: {
    status: {
      loading: 'Chargement...',
      live: 'EN DIRECT',
      complete: 'Terminé',
      correct: 'correct',
    },
    actions: {
      edit: 'Modifier',
      view: 'Voir',
      playNow: 'Jouer maintenant',
      leaderboard: 'Classement',
      viewLeaderboard: 'Voir le classement en direct',
    },
    results: {
      rank: 'Rang',
      totalPts: 'Total Pts',
    },
    labels: {
      start: 'Début:',
      picks: 'Choix:',
      firstPrize: '1er prix:',
      vs: 'vs',
      yes: 'Oui',
      no: 'Non',
    },
    time: {
      day: 'Jour',
      days: 'Jours',
      hour: 'Heure',
      hours: 'Heures',
      soon: 'Bientôt',
      startingSoon: 'Commence bientôt...',
    },
    ordinals: {
      st: 'er',
      nd: 'e',
      rd: 'e',
      th: 'e',
    },
  },
  navigation: {
    filter: 'Filtrer',
    edit: 'Modifier',
    chat: 'Discussion',
    code: 'Code',
  },
  actions: {
    clear: 'Effacer',
    quickPick: 'Choix Rapide',
    submitPicks: 'Soumettre les choix',
    submitting: 'Soumission...',
  },
  tabs: {
    play: 'Jouer',
    recent: 'Récent',
    leaderboard: 'Classement',
    friends: 'Amis',
  },
  leaderboard: {
    today: "Aujourd'hui",
    week: 'Semaine',
    month: 'Mois',
    year: 'Année',
    season: 'Saison',
    rank: 'Rang',
    user: 'Utilisateur',
    points: 'Points',
    pickem: 'Pickem',
    pickemLeaderboard: 'Classement Pickem',
    close: 'Fermer',
    scrollForMore: 'Faites défiler pour plus',
    failedToLoad: 'Échec du chargement du classement. Veuillez réessayer.',
    noData: 'Aucune donnée de classement disponible pour cette période.',
    absoluteWinner: 'Gagnant absolu - première entrée correcte soumise',
  },
  pages: {
    gamesCount: "{{count}} Matchs Pick'em à jouer",
    recentResults: 'Résultats récents ({{count}})',
    noGamesAvailable: "Actuellement, il n'y a pas de jeux PICK'EM disponibles",
    noCompletedGames: "Il n'y a pas encore de jeux PICK'EM terminés.",
  },
  common: {
    picks: 'choix',
  },
  footer: {
    termsAndConditions: 'Termes et Conditions',
  },
  tiebreaker: {
    title: "Bris d'égalité quotidien",
  },
  modal: {
    picksSubmitted: {
      title: 'Sélections soumises',
      message: 'Vos sélections BET99 F2P ont été enregistrées.',
      editMessage: "Modifiez-les à tout moment avant le coup d'envoi.",
      returnToLobby: 'Retour au Lobby',
    },
  },
} as const;

export default fr;
